import { apiClient, patientBffApiClient } from '../client/api-client'
const users = 'users'
const patients = 'patients'
const consents = 'consents'
const file = '/file'
const v2 = 'v2'

export default {
  /*
      Load user profile with UUID
  */
  async getUserProfile(uuid) {
    try {
      const { data } = await apiClient.get(`${users}/${v2}/${uuid}`)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
    Load user patients with UUID
   */
  async getUserPatients(uuid) {
    try {
      const { data } = await apiClient.get(`${users}/${v2}/${uuid}/${patients}`)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
      Load user consent with UDID
  */
  async getUserConsents(uuid) {
    try {
      const { data } = await apiClient.get(`${users}/${v2}/${uuid}/${consents}`)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
      Update User Consent
  */
  async updateUserConsent(payload) {
    try {
      const { data } = await apiClient.patch(
        `${users}/${v2}/${payload.uuid}/${consents}/${payload.consentUUID}`,
        payload.consent
      )
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
      Add User Consent
  */
  async addUserConsent(payload) {
    try {
      const { data } = await apiClient.post(
        `${users}/${v2}/${payload.uuid}/${consents}`,
        payload.consent
      )
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
    Update User profile
  */
  async updateUserProfile(uuid, payload) {
    try {
      const { data } = await apiClient.patch(`${users}/${v2}/${uuid}`, payload)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
    Update Caregiver Patient
  */
  async updateCaregiverPatientProfile(uuid, patientId, payload) {
    try {
      const { data } = await apiClient.patch(
        `${users}/${v2}/${uuid}/patients/${patientId}`,
        payload
      )
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
     Upload file
     */
  async uploadFile({ payload, path, contentType = 'application/pdf', skip = false }) {
    // eslint-disable-next-line no-useless-catch
    try {
      const headers = {
        'Content-Type': contentType,
        'X-Ciitizen-Skip': skip
      }
      const { data } = await apiClient.put(`${file}/${path}`, payload, {
        headers
      })
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
     Create Slot
     */
  async createSlot(payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      const { data } = await apiClient.post(`${file}`, payload)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
    update CaregiverPatient
  */
  async updateCaregiverPatient(payload) {
    // eslint-disable-next-line no-useless-catch
    try {
      let patientObject = {
        caregiverRelation: payload.caregiverRelation,
        patient: payload.patient
      }
      const { data } = await apiClient.patch(
        `${users}/${v2}/${payload.userId}/${patients}/${payload.patientId}`,
        patientObject
      )
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /*
    Will fetch to check if there is user is still completeing onboarding and redirect to onboarding app
  */
  async getOnboardingSession({ uuid }) {
    // eslint-disable-next-line no-useless-catch
    try {
      const { data } = await apiClient.get(`${users}/${v2}/${uuid}/session`)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  /* 
    Create Caregiver Patient
  */
  async createCaregiverPatient(uuid, payload) {
    try {
      const { data } = await apiClient.post(`${users}/${v2}/${uuid}/patients`, payload)
      return data
    } catch (err) {
      throw new Error(err)
    }
  },
  async registerUser(payload) {
    try {
      const { data } = await apiClient.post(`${users}/v2`, payload)
      return data
    } catch (err) {
      localStorage.removeItem('default_auth_token')
      localStorage.removeItem('id_token')
      throw new Error(err)
    } finally {
      localStorage.removeItem('inviteToken')
    }
  },

  // Consume from the new tasks-user endpoint that creates user, gets auth token and assigns tasks based on role
  async createUser(payload) {
    try {
      const { data } = await patientBffApiClient.post('user', payload)
      if (data) {
        localStorage.setItem('default_auth_token', data.accessToken)
        localStorage.setItem('id_token', data.idToken)
        localStorage.removeItem('inviteToken')
      }
      return data
    } catch (err) {
      localStorage.removeItem('default_auth_token')
      localStorage.removeItem('id_token')
      throw new Error(err)
    }
  }
}
